import { YesObject } from '@yes.technology/react-toolkit'

export interface UpdateSelectedObjectInUrlParams {
  searchParams: URLSearchParams
  responseObjects: YesObject[] | null
  hasPersistentSelection: boolean
  lockObjectViewObject: boolean
  hideRowActionButtons: boolean
  shouldResetObjectArea: boolean
  objectclassQueryString: string
  objectclassUuid: string
}

export const updateSelectedObjectInUrl = ({
  searchParams,
  responseObjects,
  hasPersistentSelection,
  lockObjectViewObject,
  hideRowActionButtons,
  shouldResetObjectArea,
  objectclassQueryString,
  objectclassUuid
}: UpdateSelectedObjectInUrlParams): URLSearchParams => {
  const newSearchParams = new URLSearchParams(searchParams)

  if (
    lockObjectViewObject ||
    hideRowActionButtons ||
    !responseObjects?.length ||
    !shouldResetObjectArea
  ) {
    return newSearchParams
  }

  if (!hasPersistentSelection && responseObjects.length > 0) {
    newSearchParams.set('object-uuid', responseObjects[0].uuid)
  }

  newSearchParams.set(objectclassQueryString, objectclassUuid)

  return newSearchParams
}
